import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MetricActionType, MetricModule, MetricType, Metrics } from '../models/metrics';
import { BaseService } from './base.service';

@Injectable()
export class OrderStoreUseExportService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.assortmentPim;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public exportItemStoreUse(
    wmsCode: string,
    storeCode?: string,
    provinceCode?: string,
    deliveryMethod?: string
  ): Observable<any> {
    const url = this.getFullUrl(this.envService.exportOrderList);
    // Scope for SUPPLIER (direct-to-store) prices travels as query params; pim reads it via @RequestParam.
    const params = this.getParams({ storeCode, provinceCode, wmsCode, deliveryMethod });

    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.COUNTER,
          module: MetricModule.STORE_USE,
          path: `${this.envService.url}${this.envService.exportOrderList}`,
          action: MetricActionType.EXPORT
        },
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.STORE_USE,
          route: `${this.envService.url}${this.envService.exportOrderList}`,
          action: MetricActionType.EXPORT
        }
      ]
    };

    return this.http.post<any>(
      url,
      {},
      {
        headers: this.loaderHeaders(0, metricsReq),
        observe: 'body',
        responseType: 'blob' as 'json',
        params
      }
    );
  }
}
